module.exports = __webpack_public_path__ + "static/img/2014-11-24 00.01.21.25aa1726.jpg";